(() => {
  const intro = document.querySelector('.hulfe-show-page .hulfe-show-intro .rte');
  if (!intro || intro.querySelector('.hulfe-show-inline-gallery')) return;

  const images = Array.from(intro.querySelectorAll('img'));
  if (images.length < 2) return;

  const gallery = document.createElement('div');
  gallery.className = 'hulfe-show-inline-gallery';
  gallery.setAttribute('aria-label', 'Show documentation');

  const oldParents = new Set();

  images.forEach((image) => {
    let node = image;
    if (image.parentElement && image.parentElement.tagName === 'A') {
      node = image.parentElement;
    }
    if (node.parentElement && node.parentElement !== intro) oldParents.add(node.parentElement);
    gallery.appendChild(node);
  });

  intro.prepend(gallery);
  intro.classList.add('has-hulfe-inline-gallery');

  oldParents.forEach((parent) => {
    const meaningfulText = (parent.textContent || '').replace(/\s+/g, ' ').trim();
    if (!parent.querySelector('img, video, iframe') && meaningfulText === '') parent.remove();
  });
})();
